import { Input, Menu, Tooltip } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import { NavLink } from 'react-router-dom'
import './styles/BamHeader.css'

class BamHeader extends React.PureComponent {
  render() {
    const brandName = this.props.mask
      ? this.props.mask.split('.')[0].replace(/^admin-/, '')
      : 'BAM!'
    return (
      <div className="bam-menu">
        <div
          className="bam-header__logo"
          style={{ width: this.props.logoWidth }}
        >
          <img
            className="logo logo--BAM"
            src={
              this.props.mask ? `/${brandName}-logo.png` : '/BAM-logo-v2.svg'
            }
            alt={`${brandName} logo`}
          />
        </div>
        <Menu
          className="bam-menu__center-section"
          mode="horizontal"
          selectedKeys={this.props.selectedKeys}
          onClick={this.props.handleClick}
          width={window.innerWidth - this.props.logoWidth}
        >
          {/* Leaves the DAM for the tenant's own portal, carrying the
              session (see openAppWithHandoff) -- so it is a plain button, not
              a NavLink, and never takes the selected state. */}
          <Menu.Item key="app" className="bam-menu__item">
            <Tooltip title="Open your app in a new tab" placement="bottom">
              <span className="navLink">
                <span className="button__text">
                  <i className={'fa fa-external-link bam-menu__icon'} /> App
                </span>
              </span>
            </Tooltip>
          </Menu.Item>
          <Menu.Item key="library" className="bam-menu__item">
            <NavLink
              to={`/library/${this.props.activeFolder}`}
              className="navLink"
              activeClassName="navLink_active"
            >
              <span className="button__text">
                <i className={'fa fa-database bam-menu__icon'} /> Library
              </span>
            </NavLink>
          </Menu.Item>
          {this.props.modules.builders &&
          !this.props.modules.builders.disabled &&
          this.props.isContentAdmin ? (
            <Menu.Item key="builders" className="bam-menu__item">
              <NavLink
                to="/builders/home"
                className="navLink"
                activeClassName="navLink_active"
              >
                <span className="button__text">
                  <i className={'fa fa-puzzle-piece bam-menu__icon'} /> Builders
                </span>
              </NavLink>
            </Menu.Item>
          ) : null}
          {this.props.isAdmin ? (
            <Menu.Item key="settings" className="bam-menu__item">
              <NavLink
                to={this.props.settingsLink}
                className="navLink"
                activeClassName="navLink_active"
              >
                <span className="button__text">
                  <i className={'fa fa-unlock-alt bam-menu__icon'} /> Settings
                </span>
              </NavLink>
            </Menu.Item>
          ) : null}
          {this.props.modules.analytics &&
          !this.props.modules.analytics.disabled &&
          this.props.canViewAnalytics ? (
            <Menu.Item key="analytics" className="bam-menu__item">
              <NavLink
                to="/analytics"
                className="navLink"
                activeClassName="navLink_active"
              >
                <span className="button__text">
                  <i className={'fa fa-bar-chart bam-menu__icon'} /> Analytics
                </span>
              </NavLink>
            </Menu.Item>
          ) : null}
          <Menu.Item key="profile" className="bam-menu__item">
            <NavLink
              to="/profile"
              className="navLink"
              activeClassName="navLink_active"
            >
              <span className="button__text">
                <i className={'fa fa-user bam-menu__icon'} /> Profile
              </span>
            </NavLink>
          </Menu.Item>
        </Menu>
        {!this.props.isDisabled() && (
          <div className="bam-header__search">
            <Input
              placeholder="Asset Search"
              value={this.props.searchQuery}
              onChange={this.props.onChangeSearch}
              onKeyDown={(e) => {
                if (e.key === 'Enter') this.props.onSubmitSearch()
              }}
              prefix={
                <i
                  className={'fa fa-search bam-header__search-icon'}
                  style={{ cursor: 'pointer' }}
                  onClick={this.props.onSubmitSearch}
                />
              }
              disabled={this.props.isDisabled()}
            />
          </div>
        )}
      </div>
    )
  }
}

BamHeader.propTypes = {
  isAdmin: PropTypes.bool,
  isContentAdmin: PropTypes.bool,
  canViewAnalytics: PropTypes.bool,
  isDisabled: PropTypes.func,
  settingsLink: PropTypes.string,
  handleClick: PropTypes.func,
  onChangeSearch: PropTypes.func,
  onSubmitSearch: PropTypes.func,
  selectedKeys: PropTypes.array,
  activeFolder: PropTypes.string,
  superuser: PropTypes.bool,
  searchQuery: PropTypes.string,
  logoWidth: PropTypes.number,
}

export default BamHeader
